export const graphFontSize = 14;